<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
                primary--text
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
        ></span>
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <v-form ref="form" lazy-validation>
          <v-container fluid>
            <v-row>
              <v-col cols="12" class="my-0 py-0">
                <v-combobox
                  v-model="productSelected"
                  outlined
                  clearable
                  dense
                  :label="translations.label_type"
                  item-text="name"
                  :items="productsInProject"
                  class="
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
                  :rules="validation(translations.field_required)"
                >
                  <template v-slot:item="data">
                    {{ data.item.name }} - {{ data.item.doses }}
                    {{ translations.label_dose }} -
                    {{ getProductType(data.item.type) }}
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-text-field
                  v-model="date"
                  outlined
                  clearable
                  dense
                  :label="translations.label_dose"
                  type="date"
                  :lang="language"
                  class="
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
                  :rules="validation(translations.field_required)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="newProduct"
          block
          class="
                mb-5
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
        >
          {{ translations.label_add_application }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
//VUEX
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
// Validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    date: null,
    products: [],
    productSelected: null,
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("project", ["productsInProject", "projectToUpdate"]),
    ...mapState("session", ["language"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("project", ["addApplication"]),
    async newProduct() {
      try {
        if (this.$refs.form.validate()) {
          this.productSelected.applicationDate = this.date;
          this.productSelected.uuid = uuidv4();
          let payload = {
            body: this.productSelected,
            query: {
              projectId: this.projectToUpdate._id,
            },
          };
          await this.addApplication(payload);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: this.translations.label_application_added,
            timeout: 4000,
          });
          this.$emit("addApplication", this.productSelected);
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    validation(value) {
      return requiredValidation(value);
    },
    getProductType(value) {
      return this.translations.compotition_types[value];
    },
  },
};
</script>

<style scoped></style>
